import { gql } from '@apollo/client';

export const DELETE_PORTFOLIO = gql`
  mutation DELETE_PORTFOLIO($portfolioId: Int!) {
    deletePortfolio(portfolioId: $portfolioId) {
      id
    }
  }
`;
